import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import PinnedLabel from './PinnedLabel'
import Date from './Date'
import Label from './Label'
import HTMLViewWrapper from './HTMLViewWrapper'
import { PostProps } from './types'

const StyledHtmlViewWrapper = styled.div`
  font-size: 19px;
  line-height: 1.5;
  margin: 16px 0;
`

type StyledPostProps = Pick<PostProps, 'isLast' | 'isPinned'>

const StyledPost = styled.div<StyledPostProps>`
  ${({
    theme: {
      colors: {
        brandColors: { brand_55 },
        grey: { grey_20, grey_10 },
      },
      fonts: { sourceSansPro },
    },
    isLast,
    isPinned,
  }) => css`
    display: flex;
    flex-direction: column;
    border-color: ${grey_20};
    border-style: solid;
    border-width: 2px 0 0 0;
    font-size: inherit;
    line-height: inherit;
    position: relative;

    ${tabletCSS(css`
      display: grid;
      grid-template-columns: 5.5rem minmax(0, 1fr);
    `)}

    ${desktopCSS(css`
      display: grid;
      grid-template-columns: 5.5rem minmax(0, 1fr);
    `)}

    ${mobileCSS(css`
      max-width: calc(100vw - 2 * 12px);
      box-sizing: border-box;
    `)}

    ${isLast &&
    css`
      border-bottom: 2px solid ${grey_20};
    `}

    ${isPinned &&
    css`
      background-color: ${grey_10};
      padding-right: 10px;

      ${mobileCSS(css`
        padding-left: 10px;
      `)}
    `}

    ul {
      padding-left: 1em;
    }

    ol {
      padding-left: 1.7em;
    }

    h2,
    h1,
    h3 {
      font-family: ${sourceSansPro};
      font-weight: 700;
      font-size: 22px;
      line-height: 1.3;

      &:not(:first-child) {
        margin-top: 16px;
      }
      margin-bottom: 16px;
    }

    h4 {
      font-size: 17px;
      line-height: 1.5;
      &:not(:first-child) {
        margin-top: 16px;
      }
      margin-bottom: 16px;
    }

    a {
      color: ${brand_55};
      font-weight: bold;
    }

    figure {
      figcaption {
        font-size: 14px;
        margin: 16px 0;
      }
    }

    > div {
      &:empty {
        display: none;
      }
      &:not(:first-child) {
        margin: 16px 0;
      }
      > div {
        &:not(:first-child) {
          margin: 16px 0;
        }
      }
    }

    p {
      margin: 16px 0;
    }
  `}
`

const Post: FunctionComponent<PostProps> = ({
  isLast,
  isPinned,
  metadataProps: { date, icon },
  htmlViewProps,
}) => {
  return (
    <StyledPost isLast={isLast} isPinned={isPinned}>
      <PinnedLabel isPinned={isPinned} />
      <Date isPinned={isPinned}>{date}</Date>
      <StyledHtmlViewWrapper>
        <Label icon={icon} />
        <HTMLViewWrapper {...htmlViewProps} />
      </StyledHtmlViewWrapper>
    </StyledPost>
  )
}

export default Post
